//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditableTaskName from './editable-task-name.vue';
import FormattedTaskName from './formatted-task-name.vue';
import SquareButton from './square-button.vue';
import {toggleDoneness} from '../db-utils.js';
import {calcItemColor} from '../utils.js';

export default {
  props: [
    'task',
    'parentcolor',
  ],
  data() {
    return {
      editMode: false,
    };
  },
  components: {
    EditableTaskName,
    FormattedTaskName,
    SquareButton,
  },
  computed: {
    subtasks() {
      if (this.task._id) return this.task.getChildren();
      return [];
    },
    isDone() {
      return !!this.task.doneAtTimestampMs;
    },
    itemIcon() {
      switch (this.task.type) {
        case "task": return this.isDone ? 'check_box' : 'check_box_outline_blank'
        case "goal": return this.isDone ? 'flag' : 'outlined_flag'
        case "event": return 'event'
      }
    },
    isShared() {
      return this.task.couch.collaborators.length > 1
    },
    itemColor() {
      return calcItemColor(this.task, this.$reactiveCache);
    },
  },
  methods: {
    toggleDone() {
      toggleDoneness(this.task, this);
    },
    enterEditMode() {
      this.editMode = true;
    },
    leaveEditMode() {
      this.editMode = false;
    },
    saveIfMobileEnter(event) {
      // on desktop textInput is triggered on every key (with data containig 1 char),
      // on mobile it's triggered on enter with whole input inside data.
      if (event.type === "textInput"
          && event.data.length > 1
          && event.data.slice(-1) === "\n") {
        event.preventDefault();
        this.leaveEditMode()
      }
    },
  },
  watch: {
    editMode(enabled) {
      if (enabled) {
        this.$nextTick(() => {
          this.$refs.taskName.focus();
        });
      }
    },
  },
}
